import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  title: () => i18n.t(i18nKeys.loginModal__title),
  forgotYourPassword: () => i18n.t(i18nKeys.common__forgotYourPassword),
  required: () => i18n.t(i18nKeys.common__required),
  password: () => i18n.t(i18nKeys.common__password),
  email: () => i18n.t(i18nKeys.common__email),
  placeholderEmail: () => i18n.t(i18nKeys.loginModal__placeholderEmail),
  useExistingCredentials: () =>
    i18n.t(i18nKeys.loginModal__useExistingCredentials),
  signIn: () => i18n.t(i18nKeys.common__signIn),
}
